export default __webpack_public_path__ + "static/media/web-icon.cb111e0b.svg";